module.exports = __webpack_public_path__ + "static/media/backToMainMenu.c40f1648.mp3";